import axios from 'axios';
import {errorHandler} from "./libs/lib.js";

export default {
argroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/arinv/postgroup");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}, 
bankaccount() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/bankcashacc/allaccount");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
byrsemu(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get(`arinv/byrsemu/${obj.arinvKey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'kodebank','namabank', 'reference', 'tgldue1', 'tgldue2','unearned','collector_id'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/arpaymtt${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}, 
listwithlines(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'kodebank','namabank', 'reference', 'tgldue1', 'tgldue2','unearned','collector_id','invoiceno'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/arpaymtt/listwithlines${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
    }, 

currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}, 
arpaymdetail(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get(`arpaymtt/arpaymdetail/${obj.arpaymKey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}, 
insert(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post("arpaymtt", obj);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}, 
remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.delete(`arpaymtt/${obj.arpaymKey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}, 
potongan() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/arpaymtt/potongan");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}, 
printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
        let url;
        let str = '';
        try {
            str = '?key=' + encodeURIComponent(obj.arpaymKey);
            url = `/arpaymtt/printjv`;

            url += str;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}, 
exportXls(obj = {}) {
    const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'kodebank','namabank', 'reference', 'tgldue1', 'tgldue2', 'unearned', 'collector_id'];

    let str = '';
    for (const key in obj) {
        if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
        }
    }

    axios({
        url: `/arpaymtt/exportxls${str}`,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ar_payment.xlsx');
        document.body.appendChild(link);
        link.click();
        // window.location.assign(url);
    });

},
exportwithlines(obj = {}) {
    const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'kodebank','namabank', 'reference', 'tgldue1', 'tgldue2', 'unearned', 'collector_id','invoiceno'];

    let str = '';
    for (const key in obj) {
        if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
        }
    }

    axios({
        url: `/arpaymtt/exportwithlines${str}`,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ar_payment_with_invoice.xlsx');
        document.body.appendChild(link);
        link.click();
        // window.location.assign(url);
    });

}
};